import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldoCategoria } from '../../_models/tipo-respaldo-categoria';
import { TipoRespaldoSubcategoriaService } from '../../_services/tipo-respaldo-subcategoria.service';
import { TipoRespaldoSubcategoria } from '../../_models/tipo-respaldo-subcategoria';
import { CentroLlamadaCentralizador } from '../../_models/centro-llamada-centralizador';

@Component( {
  selector: 'app-tipo-respaldo-subcategoria',
  templateUrl: 'tipo-respaldo-subcategoria.component.html'
} )

export class TipoRespaldoSubcategoriaComponent implements OnInit {


  @Input()
  set respaldoCategoria( respaldoCategoria: TipoRespaldoCategoria ) {
    this._respaldoCategoria = respaldoCategoria;
    this.cargaInicial();
  }

  get respaldoCategoria(): TipoRespaldoCategoria {
    return this._respaldoCategoria;
  }
  @Output() respaldoSubcategoriaEvent: EventEmitter<TipoRespaldoSubcategoria> = new EventEmitter();
  @Output() tabEvent: EventEmitter<string> = new EventEmitter();
  _respaldoCategoria: TipoRespaldoCategoria;
  respaldoSubcategoria: TipoRespaldoSubcategoria;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  lisTipoRespaldoSubcategoria: TipoRespaldoSubcategoria[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private serTipoRespaldoSubcategoria: TipoRespaldoSubcategoriaService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private router: Router ) {
  }

  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial(){
    if ( this._respaldoCategoria &&
      (this._respaldoCategoria.idTipoRespaldoCategoria !== '' && this._respaldoCategoria.idTipoRespaldoCategoria !== null && this._respaldoCategoria.idTipoRespaldoCategoria !== undefined) &&
      this._respaldoCategoria.indicadorSubcategoria ) {
      /** Se traen todos los seguros planes que pertenezcan al seguro actual */
      this.serTipoRespaldoSubcategoria.listarTodosPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( tipoRespaldoSubcategoria => {
      // this.serTipoRespaldoSubcategoria.listadoPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( tipoRespaldoSubcategoria => {
        this.lisTipoRespaldoSubcategoria = tipoRespaldoSubcategoria;
        this.carServiciosIniciales();
      } );
    }
  }

  carServiciosIniciales() {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-respaldo-subcategoria' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_CODSUBCAT' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_NOMSUBCAT' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_ADJUNTO' ), sort: true },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idTipoRespaldoSubCategoria: [ this.respaldoSubcategoria ? this.respaldoSubcategoria.idTipoRespaldoSubCategoria : null ],
      idTipoRespaldoCategoria: [ this._respaldoCategoria.idTipoRespaldoCategoria, [ Validators.required ] ],
      codigo: [ this.respaldoSubcategoria ? this.respaldoSubcategoria.codigo : null, [ Validators.required ] ],
      nombre: [ this.respaldoSubcategoria ? this.respaldoSubcategoria.nombre : null, [ Validators.required ] ],
      indicadorManejaAdjunto: [ false, [ Validators.required ] ],
      indicadorHabilitado: [ true, [ Validators.required ] ],
    } );

    this.busqueda = this.navServicio.getSearch( 'tipo-respaldo-subcategoria.component' );
    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      if ( this.respaldoSubcategoria &&
          (this.respaldoSubcategoria.idTipoRespaldoSubCategoria !== '' && this.respaldoSubcategoria.idTipoRespaldoSubCategoria !== null && this.respaldoSubcategoria.idTipoRespaldoSubCategoria !== undefined) ) {
        /** Se actualiza la categoría */
        this.serTipoRespaldoSubcategoria.actualizar( formulario ).subscribe( tipoRespaldoCategoria => {
          this.lisTipoRespaldoSubcategoria = [];
          this.serTipoRespaldoSubcategoria.listarTodosPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
          // this.serTipoRespaldoSubcategoria.listadoPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
            this.lisTipoRespaldoSubcategoria = lisRespaldoCategoria;
            this.guardando = false;
            this.submitted = false;
            this.codExiste = false;
            this.carTabla = false;
            this.respaldoSubcategoria = null;
            this.formulario.reset();
            this.f.idTipoRespaldoCategoria.setValue( this._respaldoCategoria.idTipoRespaldoCategoria );
            this.f.indicadorHabilitado.setValue( true );

            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
            } );
          } );
        } );
      } else {
        /** Se crea la categoría */
        this.serTipoRespaldoSubcategoria.crear( formulario ).subscribe( tipoRespaldoCategoria => {
          this.lisTipoRespaldoSubcategoria = [];
          this.serTipoRespaldoSubcategoria.listarTodosPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
          // this.serTipoRespaldoSubcategoria.listadoPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
            this.lisTipoRespaldoSubcategoria = lisRespaldoCategoria;
            this.guardando = false;
            this.submitted = false;
            this.codExiste = false;
            this.carTabla = false;
            this.respaldoSubcategoria = null;
            this.formulario.reset();
            this.f.idTipoRespaldoCategoria.setValue( this._respaldoCategoria.idTipoRespaldoCategoria );
            this.f.indicadorHabilitado.setValue( true );

            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_CREO' )
            } );
          } );
        } );
      }

    } else {
      if ( this.codExiste ) {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ERRORCODSUBCAT' )
        } );
      }
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


  validarCodigo() {
    this.codExiste = this.lisTipoRespaldoSubcategoria.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-respaldo-subcategoria.component', this.busqueda );
  }

  visualizar( tipoRespaldo: TipoRespaldoSubcategoria ) {
    this.router.navigate( [ 'apl/tipo-respaldo/detalle-subcategoria/' + tipoRespaldo.idTipoRespaldoSubCategoria ] );
  }

  editar( tipoRespaldo: TipoRespaldoSubcategoria ) {
    this.respaldoSubcategoria = tipoRespaldo;
    this.formulario.reset();
    this.f.idTipoRespaldoCategoria.setValue( this.respaldoSubcategoria.idTipoRespaldoCategoria );
    this.f.idTipoRespaldoSubCategoria.setValue( this.respaldoSubcategoria.idTipoRespaldoSubCategoria );
    this.f.codigo.setValue( this.respaldoSubcategoria.codigo );
    this.f.nombre.setValue( this.respaldoSubcategoria.nombre );
    this.f.indicadorManejaAdjunto.setValue( this.respaldoSubcategoria.indicadorManejaAdjunto );
    this.f.indicadorHabilitado.setValue( this.respaldoSubcategoria.indicadorHabilitado );
  }

  agregarClaseSubclase( tipoRespaldo: TipoRespaldoSubcategoria ) {
    this.respaldoSubcategoriaEvent.emit( tipoRespaldo );
    this.tabEvent.emit('CLAS');
  }

  cancelarActualizar() {
    this.respaldoSubcategoria = null;
  }

  cambioEstadoIndicadorAdjunto( item: TipoRespaldoSubcategoria  ) {
    this.guardando = true;
    this.carTabla = true;
    const formulario = this.formulario.getRawValue();
    formulario.idTipoRespaldoCategoria = item.idTipoRespaldoCategoria
    formulario.idTipoRespaldoSubCategoria = item.idTipoRespaldoSubCategoria
    formulario.codigo = item.codigo
    formulario.nombre = item.nombre
    formulario.indicadorManejaAdjunto = item.indicadorManejaAdjunto
    formulario.indicadorHabilitado = item.indicadorHabilitado
    /** Se actualiza la categoría desde el datatable*/
    this.serTipoRespaldoSubcategoria.actualizar( formulario ).subscribe( tipoRespaldoCategoria => {
      this.lisTipoRespaldoSubcategoria = [];
      this.serTipoRespaldoSubcategoria.listarTodosPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
        // this.serTipoRespaldoSubcategoria.listadoPorIdRespaldoCategoria( this._respaldoCategoria.idTipoRespaldoCategoria ).subscribe( lisRespaldoCategoria => {
        this.lisTipoRespaldoSubcategoria = lisRespaldoCategoria;
        this.guardando = false;
        this.submitted = false;
        this.codExiste = false;
        this.carTabla = false;
        this.respaldoSubcategoria = null;
        this.formulario.reset();
        this.f.idTipoRespaldoCategoria.setValue( this._respaldoCategoria.idTipoRespaldoCategoria );
        this.f.indicadorHabilitado.setValue( true );

        this.navServicio.setMesage( 0, {
          severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
        } );
      } );
    } );
  }
}
